function TechnologyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="22"
      height="22"
      aria-hidden="true"
    >
      {/* CPU / chip body */}
      <rect x="7" y="7" width="10" height="10" rx="1" />
      {/* Top pins */}
      <line x1="9" y1="2" x2="9" y2="7" />
      <line x1="12" y1="2" x2="12" y2="7" />
      <line x1="15" y1="2" x2="15" y2="7" />
      {/* Bottom pins */}
      <line x1="9" y1="17" x2="9" y2="22" />
      <line x1="12" y1="17" x2="12" y2="22" />
      <line x1="15" y1="17" x2="15" y2="22" />
      {/* Left pins */}
      <line x1="2" y1="9" x2="7" y2="9" />
      <line x1="2" y1="12" x2="7" y2="12" />
      <line x1="2" y1="15" x2="7" y2="15" />
      {/* Right pins */}
      <line x1="17" y1="9" x2="22" y2="9" />
      <line x1="17" y1="12" x2="22" y2="12" />
      <line x1="17" y1="15" x2="22" y2="15" />
    </svg>
  )
}

export default TechnologyIcon
